module.exports = __webpack_public_path__ + "img/music-promotion-facebook.1651c05a.jpg";